export default __webpack_public_path__ + "static/media/boy.4e704721.jpg";